"use client";
import React, { useEffect, useState } from "react";
import SearchProduct from "@/common/SearchProduct";
import Image from "next/image";
import { CloseCircle } from "iconsax-react";

import Modal from "@/common/Modal";
import NavCollapse from "../NavContent/NavCollapse";
import Link from "next/link";
import useSoftSetting from "@/hooks/useSoftSetting";
import Skeleton from "react-loading-skeleton";
import CloseBasketIcon from "@/components/Svg/CloseBasketIcon";
import HamburgurMenu from "@/components/Svg/HamburgurMenu";

function RightSectionTopbar() {
  const { data: softSetting, isLoading } = useSoftSetting();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleCloseModal = () => {
    setIsMenuOpen(false);
  };
  const flexItems = `flex items-center`;

  return (
    <div className={`${flexItems} gap-0 sm:gap-5`}>
      <button
        className="text-xl  hidden hamburgur-menu  "
        onClick={() => setIsMenuOpen((prev) => !prev)}
      >
        {isMenuOpen ? (
          <CloseCircle size={30} color="#686868" />
        ) : (
          <HamburgurMenu />
        )}
      </button>
      <Link
        href="/"
        className="flex items-center  justify-center gap-5 flex-row-reverse sm:relative absolute sm:left-0 left-1/2 sm:flex-row sm:w-[unset] sm:h-[unset] h-auto w-11.25"
      >
        {isMounted ? (
          !isLoading ? (
            <Image
              priority
              fetchPriority="high"
              sizes="100vw"
              unoptimized
              width={500}
              height={300}
              className="w-full sm:w-11.25 h-auto lg:h-auto  object-cover cursor-pointer"
              src={
                softSetting?.mainLogo
                  ? `${process.env.NEXT_PUBLIC_ADMIN_URL}${softSetting?.mainLogo}`
                  : "/images/default.png"
              }
              alt="logo"
            />
          ) : (
            <Skeleton
              borderRadius={10}
              baseColor="#ccc"
              width={120}
              height={38}
            />
          )
        ) : null}
      </Link>
      <SearchProduct />

      <Modal
        backdrop={false}
        backdropClosable
        scroll={true}
        modalCustomClass=" z-[2000] rounded-none"
        isOpen={isMenuOpen}
        enterFrom="right"
        position="rightFull"
        size="medium"
        modalTitleClass="w-full"
        modalTitle={
          <>
            <div className="flex items-center w-full justify-between ">
              <h2 className="text-xl lg:text-xl text-ws-gray-700 ">
                دسته بندی ها
              </h2>
              <CloseBasketIcon
                className="cursor-pointer w-4 h-4"
                onClick={() => setIsMenuOpen(false)}
              />
            </div>
          </>
        }
        modalHeaderClass=" px-5 text-lg  text-ws-gray-700 px-10 border-b-0"
        onClose={handleCloseModal}
        modalBodyClass=" modal-px-0  "
      >
        <div className={`${flexItems} justify-between flex-col    `}>
          <NavCollapse setIsMenuOpen={setIsMenuOpen} />
        </div>
      </Modal>
    </div>
  );
}

export default RightSectionTopbar;
